/* Pendelle — JS propre à la zone collection (fichier de l’agent COLLECTION/RECHERCHE). Chargé en defer après pendelle.js (window.PD disponible).
   Filtres de la page collection et de la recherche, comme la maquette (cases à cocher, curseur de prix, tri, filtres actifs,
   pastilles de famille, « Effacer », « Voir plus ») mais sur le vrai catalogue :
   - étiquettes : adresse /collections/<handle>/<etiquette1>+<etiquette2> (filtrage par étiquettes Shopify) ;
   - filtres natifs : paramètres filter.* (prix, disponibilité, options de variante) ; tri : sort_by.
   La page est mise à jour sans rechargement (API de rendu des sections) ; en cas d'échec, navigation classique. */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var PD = window.PD || {};
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function root() { return $('[data-pd-coll]'); }
  function ovf() { return $('.layers [data-pd-ovf]') || $('[data-pd-ovf]'); }

  /* le tiroir de filtres mobile rejoint les calques communs (au-dessus de l'en-tête) */
  function hoist() {
    var L = $('.layers'); if (!L) return;
    $$('[data-pd-ovf]').forEach(function (ov) {
      if (ov.parentNode === L) return;
      $$('[data-pd-ovf]', L).forEach(function (old) { if (old !== ov) old.parentNode.removeChild(old); });
      L.appendChild(ov);
    });
  }

  /* ------------------------------------------------------------ état courant → adresse */
  function state() {
    var r = root();
    var tags = ((r && r.getAttribute('data-tags')) || '').split('+').filter(Boolean);
    var p = new URLSearchParams(window.location.search);
    p.delete('page'); p.delete('section_id');
    return { tags: tags, p: p };
  }
  function urlOf(st) {
    var r = root();
    var base = (r && r.getAttribute('data-base')) || window.location.pathname;
    var path = base + (st.tags.length ? '/' + st.tags.join('+') : '');
    var q = st.p.toString();
    return path + (q ? '?' + q : '');
  }
  function withSection(url, sid) {
    var u = new URL(url, window.location.origin);
    u.searchParams.delete('section_id');
    u.searchParams.set('section_id', sid);
    return u.pathname + u.search;
  }
  function removeValues(p, name, vals) {
    var keep = p.getAll(name).filter(function (x) { return vals.indexOf(x) < 0; });
    p.delete(name); keep.forEach(function (x) { p.append(name, x); });
  }

  /* ------------------------------------------------------------ chargement + remplacement des zones */
  var seq = 0;
  function parts(scope) {
    var m = {}; if (!scope) return m;
    $$('[data-part]', scope).forEach(function (el) { m[el.getAttribute('data-part')] = el; });
    return m;
  }
  function openState(box) {
    var s = {}; if (!box) return s;
    $$('.fg', box).forEach(function (g) { var b = $('button', g); if (b) s[g.getAttribute('data-g')] = b.getAttribute('aria-expanded') === 'true'; });
    return s;
  }
  function applyOpen(box, s) {
    if (!box) return;
    $$('.fg', box).forEach(function (g) {
      var k = g.getAttribute('data-g'); if (!(k in s)) return;
      var b = $('button', g), fb = $('.fb', g); if (!b || !fb) return;
      b.setAttribute('aria-expanded', String(s[k])); fb.classList.toggle('open', s[k]);
    });
  }
  function refresh(el) {
    if (!el) return;
    if (PD.nb) PD.nb(el);
    if (PD.fillEta) PD.fillEta(el);
  }
  function load(url, push) {
    var r = root(); if (!r) { window.location.href = url; return; }
    var sid = r.getAttribute('data-section'), my = ++seq;
    r.classList.add('is-loading');
    fetch(withSection(url, sid), { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (res) { if (!res.ok) throw new Error('http'); return res.text(); })
      .then(function (html) {
        if (my !== seq) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nr = $('[data-pd-coll]', doc); if (!nr) throw new Error('vide');
        var oldP = parts(r), ov = ovf(), oldO = parts(ov);
        Object.keys(oldO).forEach(function (k) { oldP[k] = oldO[k]; });
        var newP = parts(nr);
        /* structure différente (ex. 0 ↔ plusieurs résultats, filtres apparus) : on remplace tout */
        var same = Object.keys(newP).length > 0 && Object.keys(newP).length === Object.keys(oldP).length && Object.keys(newP).every(function (k) { return oldP[k]; });
        if (!same) {
          var wasOpen = ov && ov.classList.contains('open');
          r.parentNode.replaceChild(document.importNode(nr, true), r);
          if (ov) ov.parentNode.removeChild(ov);
          hoist();
          var nr2 = root(); if (PD.observe) PD.observe(nr2); refresh(nr2);
          var nov = ovf(); if (nov) refresh(nov);
          if (wasOpen && nov && PD.openLayer) PD.openLayer(nov.id);
        } else {
          var sD = openState(oldP.fd), sM = openState(oldP.fm);
          r.setAttribute('data-tags', nr.getAttribute('data-tags') || '');
          Object.keys(newP).forEach(function (k) { oldP[k].innerHTML = newP[k].innerHTML; });
          applyOpen(oldP.fd, sD); applyOpen(oldP.fm, sM);
          var g = oldP.grid;
          if (g) {
            g.classList.remove('anim'); void g.offsetWidth; if (!RM) g.classList.add('anim');
            $$('[data-rv]', g).forEach(function (x) { x.classList.add('in'); });
          }
          Object.keys(oldP).forEach(function (k) { refresh(oldP[k]); });
        }
        if (push) { try { history.pushState({ pdColl: 1 }, '', url); } catch (e) {} }
        lastKey = window.location.pathname + window.location.search;
      })
      .catch(function () { if (my === seq) window.location.href = url; })
      .then(function () { var r2 = root(); if (r2 && my === seq) r2.classList.remove('is-loading'); });
  }
  function go(st) { load(urlOf(st), true); }

  /* ------------------------------------------------------------ « Voir plus » */
  function more(a) {
    var r = root(); if (!r) return;
    var sid = r.getAttribute('data-section'), href = a.getAttribute('href');
    a.classList.add('is-loading'); a.setAttribute('aria-busy', 'true');
    fetch(withSection(href, sid), { credentials: 'same-origin' })
      .then(function (res) { if (!res.ok) throw new Error('http'); return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nr = $('[data-pd-coll]', doc); if (!nr) throw new Error('vide');
        var cur = parts(r), nw = parts(nr);
        if (cur.grid && nw.grid) {
          $$('.card', nw.grid).forEach(function (c) {
            var n = document.importNode(c, true); cur.grid.appendChild(n);
          });
          if (PD.observe) PD.observe(cur.grid);
        }
        if (cur.other && nw.other) {
          $$('li', nw.other).forEach(function (li) { cur.other.appendChild(document.importNode(li, true)); });
          if (cur.other.children.length) cur.other.hidden = false;
        }
        if (cur.more && nw.more) cur.more.innerHTML = nw.more.innerHTML;
        Object.keys(cur).forEach(function (k) { if (k === 'grid' || k === 'other' || k === 'more') refresh(cur[k]); });
      })
      .catch(function () { window.location.href = href; });
  }

  /* ------------------------------------------------------------ mode « dans la page » (comme la maquette)
     Toute la sélection est dans la page (data-client + JSON data-cdata) : OU dans un groupe, ET entre les groupes,
     nombres recalculés, groupes de moins de 2 choix masqués, taille (diamètre) et couleur de lumière lues
     sur les fiches, curseur de prix « jusqu'à », tri, pastilles de famille, « Voir plus » sans rechargement. */
  var DLBL = { s: "Jusqu'à 40 cm", m: '41 à 60 cm', l: 'Plus de 60 cm' };
  var LUMS = [['chaude', 'Blanc chaud', '#F3BE6E'], ['neutre', 'Blanc neutre', '#F6EBD6'], ['froide', 'Blanc froid', '#DCE8F6'], ['reglable', 'Réglable', 'linear-gradient(90deg,#F3BE6E,#DCE8F6)']];
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function ico(n) { return '<svg class="ico"><use href="#' + n + '"/></svg>'; }
  function eur(c) { return (PD.money ? PD.money(c) : (c / 100).toFixed(2).replace('.', ',') + ' €').replace(',00', ''); }
  function dcls(arr) {
    var r = {};
    (arr || []).forEach(function (s) {
      s = String(s || ''); var k = s.search(/[Øø]/); if (k < 0) return;
      var seg = s.slice(k + 1), c = seg.indexOf('cm'); if (c > -1) seg = seg.slice(0, c);
      (seg.match(/\d+(?:[.,]\d+)?/g) || []).forEach(function (x) { var d = parseFloat(x.replace(',', '.')); if (!d) return; r[d <= 40 ? 's' : (d <= 60 ? 'm' : 'l')] = 1; });
    });
    return r;
  }
  function lums(arr, tags) {
    var r = {};
    (arr || []).concat((tags || []).filter(function (t) { return t.indexOf('lumiere:') === 0; })).forEach(function (s) {
      s = String(s || '').toLowerCase();
      if (/chaud/.test(s)) r.chaude = 1;
      if (/neutre/.test(s)) r.neutre = 1;
      if (/froid/.test(s)) r.froide = 1;
      if (/r[ée]glable/.test(s)) r.reglable = 1;
    });
    return r;
  }
  function pretty(t, pre) { var s = t.slice(pre.length).replace(/-/g, ' '); return s.charAt(0).toUpperCase() + s.slice(1); }

  function cinit(r) {
    if (!r || !r.hasAttribute('data-client')) return null;
    if (r.__c) return r.__c;
    var js = $('[data-cdata]', r), grid = $('[data-cgrid]', r); if (!js || !grid) return null;
    var D; try { D = JSON.parse(js.textContent); } catch (e) { return null; }
    var cards = $$(':scope > .card', grid);
    if (cards.length !== D.products.length) return null;
    var LBL = {}, ORD = []; (D.labels || []).forEach(function (l) { LBL[l[0]] = l[1]; ORD.push(l[0]); });
    var P = D.products.map(function (p, i) { return { i: i, el: cards[i], t: p.t || [], p: +p.p || 0, n: p.n || '', d: dcls(p.d), l: lums(p.l, p.t) }; });
    /* groupes et choix (définis une fois sur toute la sélection) */
    var G = [];
    (D.groups || []).forEach(function (g) {
      var key = g[0], pre = key + ':', opts = [], seen = {};
      function addTag(t) { if (seen[t]) return; seen[t] = 1; opts.push({ v: t, lab: LBL[t] || pretty(t, pre), test: function (p) { return p.t.indexOf(t) > -1; } }); }
      ORD.forEach(function (t) { if (t.indexOf(pre) === 0 && P.some(function (p) { return p.t.indexOf(t) > -1; })) addTag(t); });
      var extra = []; P.forEach(function (p) { p.t.forEach(function (t) { if (t.indexOf(pre) === 0 && !seen[t] && extra.indexOf(t) < 0) extra.push(t); }); });
      extra.sort().forEach(addTag);
      if (opts.length < 2 && key === 'taille') {
        opts = ['s', 'm', 'l'].map(function (k) { return { v: k, lab: DLBL[k], test: function (p) { return !!p.d[k]; } }; });
      } else if (opts.length < 2 && key === 'lumiere') {
        opts = LUMS.map(function (o) { return { v: o[0], lab: o[1], dot: o[2], test: function (p) { return !!p.l[o[0]]; } }; });
      } else if (key === 'lumiere') {
        opts.forEach(function (o) { LUMS.forEach(function (l) { if (o.lab.toLowerCase() === l[1].toLowerCase()) o.dot = l[2]; }); });
      }
      G.push({ k: key, t: g[1], open: !!g[2], o: opts });
    });
    var mins = P.map(function (p) { return p.p; });
    var c = {
      r: r, grid: grid, D: D, P: P, G: G, F: {}, MAX: 0, SUB: '', SORT: 'reco', per: +D.per || 24, cols: +D.cols || 3,
      unit: D.unit || ['modèle', 'modèles'],
      pmin: P.length ? Math.floor(Math.min.apply(null, mins) / 1000) * 10 : 0,
      pmax: P.length ? Math.ceil(Math.max.apply(null, mins) / 1000) * 10 : 0,
      tpl: $('template[data-ctile]', r)
    };
    c.LIM = c.per;
    G.forEach(function (g) { c.F[g.k] = {}; });
    var pr = $('[data-subraw][aria-pressed="true"]', r); if (pr) c.SUB = pr.getAttribute('data-subraw') || '';
    r.__c = c;
    crender(c, false);
    return c;
  }
  function cmatch(c, p, skip) {
    if (c.SUB && p.t.indexOf(c.SUB) < 0) return false;
    for (var i = 0; i < c.G.length; i++) {
      var g = c.G[i]; if (g.k === skip) continue;
      var ks = Object.keys(c.F[g.k]).filter(function (k) { return c.F[g.k][k]; }); if (!ks.length) continue;
      if (!g.o.some(function (o) { return ks.indexOf(o.v) > -1 && o.test(p); })) return false;
    }
    if (c.MAX && skip !== 'max' && p.p > c.MAX * 100) return false;
    return true;
  }
  function cword(c, n) { return n + ' ' + (n > 1 ? c.unit[1] : c.unit[0]); }
  function cfilters(c, sfx) {
    var h = '';
    c.G.forEach(function (g) {
      var items = g.o.map(function (o) {
        var n = c.P.filter(function (p) { return cmatch(c, p, g.k) && o.test(p); }).length;
        return [o, n];
      }).filter(function (x) { return x[1] > 0 || c.F[g.k][x[0].v]; });
      if (items.length < 2) return;
      h += '<div class="fg" data-g="' + esc(g.k) + '"><button type="button" aria-expanded="' + g.open + '">' + esc(g.t) + '<span class="pm"></span></button><div class="fb' + (g.open ? ' open' : '') + '"><div><div class="in">' +
        items.map(function (x) {
          var o = x[0];
          return '<label class="ck"><input type="checkbox" data-cf="' + esc(g.k) + '" value="' + esc(o.v) + '"' + (c.F[g.k][o.v] ? ' checked' : '') + '><span class="box"></span>' + (o.dot ? '<span class="dot" style="background:' + o.dot + '"></span>' : '') + esc(o.lab) + '<small>' + x[1] + '</small></label>';
        }).join('') + '</div></div></div></div>';
    });
    if (c.pmax > c.pmin) {
      var cv = c.MAX || c.pmax;
      h += '<div class="fg" data-g="prix"><button type="button" aria-expanded="true">Prix<span class="pm"></span></button><div class="fb open"><div><div class="in price-f"><label class="sr" for="pmax-' + sfx + '">Prix maximum</label><input type="range" id="pmax-' + sfx + '" data-fmax min="' + c.pmin + '" max="' + c.pmax + '" step="10" value="' + cv + '"><div class="v"><span>' + eur(c.pmin * 100) + '</span><span>jusqu\'à <b data-fmaxv>' + eur(cv * 100) + '</b></span></div></div></div></div></div>';
    }
    return h;
  }
  function csorted(c, l) {
    l = l.slice();
    if (c.SORT === 'asc') l.sort(function (a, b) { return a.p - b.p || a.i - b.i; });
    else if (c.SORT === 'desc') l.sort(function (a, b) { return b.p - a.p || a.i - b.i; });
    else if (c.SORT === 'az') l.sort(function (a, b) { return a.n.localeCompare(b.n, 'fr'); });
    else l.sort(function (a, b) { return a.i - b.i; });
    return l;
  }
  function crender(c, anim) {
    var r = c.r, ov = ovf(), P1 = parts(r), P2 = parts(ov), g = c.grid;
    /* filtres (on garde les groupes ouverts/fermés par le visiteur) */
    [[P1.fd, 'd'], [P2.fm, 'm']].forEach(function (x) {
      if (!x[0]) return; var s = openState(x[0]);
      x[0].innerHTML = cfilters(c, x[1]); applyOpen(x[0], s); refresh(x[0]);
    });
    /* grille */
    var list = csorted(c, c.P.filter(function (p) { return cmatch(c, p); }));
    var n = list.length, shown = Math.min(n, c.LIM), on = {};
    var old = $(':scope > .empty', g); if (old) old.parentNode.removeChild(old);
    var tile = $(':scope > [data-ctile]', g);
    if (!tile && c.tpl) { tile = c.tpl.content.firstElementChild.cloneNode(true); }
    list.forEach(function (p, i) { on[p.i] = 1; p.el.hidden = i >= shown; p.el.setAttribute('data-rv', String((i % 3) + 1)); g.appendChild(p.el); });
    c.P.forEach(function (p) { if (!on[p.i]) { p.el.hidden = true; g.appendChild(p.el); } });
    if (tile) {
      if (shown >= 3) {
        var cols = c.cols, span = shown % cols === 0 ? cols : cols - shown % cols, at = span === cols ? cols : shown;
        tile.className = 'edit-tile sp' + span + (span === cols ? ' wide' : '') + (tile.classList.contains('in') ? ' in' : '');
        var ref = list[at] && at < shown ? list[at].el : (list[shown] ? list[shown].el : null);
        if (ref) g.insertBefore(tile, ref); else g.appendChild(tile);
        tile.hidden = false;
      } else if (tile.parentNode) tile.parentNode.removeChild(tile);
    }
    if (!n) {
      var e = document.createElement('div'); e.className = 'empty';
      e.innerHTML = '<h3>Aucun modèle ne correspond.</h3><p class="muted">Retirez un filtre pour élargir la sélection.</p><button type="button" class="btn btn-o" data-freset>Effacer les filtres</button>';
      g.insertBefore(e, g.firstChild);
    }
    g.classList.add('ready');
    if (anim) {
      g.classList.remove('anim'); void g.offsetWidth; if (!RM) g.classList.add('anim');
      $$('[data-rv]', g).forEach(function (x) { x.classList.add('in'); });
    }
    /* barre collante, filtres actifs, « Voir plus » */
    var act = [];
    c.G.forEach(function (gr) { gr.o.forEach(function (o) { if (c.F[gr.k][o.v]) act.push('<button type="button" data-fx="' + esc(gr.k) + '|' + esc(o.v) + '" aria-label="Retirer le filtre ' + esc(o.lab) + '">' + esc(o.lab) + ico('i-close') + '</button>'); }); });
    if (c.MAX) act.push('<button type="button" data-fx="max|0" aria-label="Retirer le filtre Jusqu\'à ' + esc(eur(c.MAX * 100)) + '">Jusqu\'à ' + eur(c.MAX * 100) + ico('i-close') + '</button>');
    if (P1.act) P1.act.innerHTML = act.join('');
    if (P1.fn) P1.fn.textContent = act.length ? ' (' + act.length + ')' : '';
    if (P1.cnt2) P1.cnt2.textContent = cword(c, n);
    if (P2.fshow) P2.fshow.textContent = n ? (n > 1 ? 'Voir les ' + cword(c, n) : 'Voir le ' + c.unit[0]) : 'Aucun ' + c.unit[0];
    if (P1.more) {
      var tr = $('.track i', P1.more); if (tr) tr.style.setProperty('--p', (n ? Math.round(shown / n * 100) : 100) + '%');
      var tx = $('[data-cmoretxt]', P1.more); if (tx) tx.textContent = n ? 'Vous avez vu ' + cword(c, shown) + ' sur ' + n : 'Aucun ' + c.unit[0];
      var mb = $('[data-cmore]', P1.more); if (mb) mb.hidden = shown >= n;
    }
    [P1.act, P1.cnt2, P1.more, P2.fshow].forEach(function (x) { if (x && PD.nb) PD.nb(x); });
    if (!anim && PD.observe) PD.observe(g);
  }
  function creset(c) {
    c.G.forEach(function (g) { c.F[g.k] = {}; }); c.MAX = 0; c.SUB = ''; c.LIM = c.per;
    $$('[data-subraw]', c.r).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-subraw') === '')); });
  }
  /* renvoie true si l'événement a été traité en mode « dans la page » */
  function chandle(e) {
    var r = root(), c = r && r.__c; if (!c) return false;
    var t = e.target, el;
    if (e.type === 'change') {
      if (t.matches('input[data-cf]')) { c.F[t.getAttribute('data-cf')][t.value] = t.checked; c.LIM = c.per; crender(c, true); return true; }
      if (t.matches('[data-fmax]')) { var v = +t.value; c.MAX = v >= +t.max ? 0 : v; c.LIM = c.per; crender(c, true); return true; }
      if (t.matches('select[data-csort]')) { c.SORT = t.value; crender(c, true); return true; }
      return false;
    }
    if ((el = t.closest('[data-fx]'))) { e.preventDefault(); var a = el.getAttribute('data-fx').split('|'); if (a[0] === 'max') c.MAX = 0; else if (c.F[a[0]]) c.F[a[0]][a.slice(1).join('|')] = false; crender(c, true); return true; }
    if ((el = t.closest('[data-freset]'))) { e.preventDefault(); creset(c); crender(c, true); return true; }
    if ((el = t.closest('[data-subraw]'))) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return true;
      e.preventDefault(); c.SUB = el.getAttribute('data-subraw') || ''; c.LIM = c.per;
      $$('[data-subraw]', r).forEach(function (b) { b.setAttribute('aria-pressed', String(b === el)); });
      crender(c, true); return true;
    }
    if ((el = t.closest('[data-cmore]'))) { e.preventDefault(); c.LIM += c.per; crender(c, false); return true; }
    return false;
  }

  /* ------------------------------------------------------------ événements */
  function inZone(t) { return t.closest('[data-pd-coll]') || t.closest('[data-pd-ovf]'); }

  document.addEventListener('change', function (e) {
    var t = e.target; if (!t.closest || !inZone(t)) return;
    if (chandle(e)) return;
    var st;
    if (t.matches('input[data-tag]')) {
      st = state(); var h = t.getAttribute('data-tag');
      st.tags = st.tags.filter(function (x) { return x !== h; });
      if (t.checked) st.tags.push(h);
      go(st); return;
    }
    if (t.matches('input[data-param]')) {
      st = state(); var name = t.getAttribute('data-param');
      var vals = t.hasAttribute('data-values') ? t.getAttribute('data-values').split('||') : [t.value];
      if (t.checked) { var have = st.p.getAll(name); vals.forEach(function (v) { if (have.indexOf(v) < 0) st.p.append(name, v); }); }
      else removeValues(st.p, name, vals);
      go(st); return;
    }
    if (t.matches('[data-fmax]')) {
      st = state(); var v = +t.value, mx = +t.max;
      if (v >= mx) st.p.delete('filter.v.price.lte'); else st.p.set('filter.v.price.lte', String(v));
      go(st); return;
    }
    if (t.matches('select[data-sort]')) {
      st = state(); st.p.set('sort_by', t.value); go(st); return;
    }
  });
  document.addEventListener('input', function (e) {
    var t = e.target; if (!t.matches || !t.matches('[data-fmax]')) return;
    var txt = (PD.money ? PD.money(+t.value * 100) : t.value + ',00 €').replace(',00', '');
    $$('[data-fmaxv]').forEach(function (x) { x.textContent = txt; });
    $$('[data-fmax]').forEach(function (x) { if (x !== t) x.value = t.value; });
  });
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest || !inZone(t)) return;
    if (chandle(e)) return;
    var el, st;
    if ((el = t.closest('[data-rmtag]'))) {
      e.preventDefault(); st = state(); var h = el.getAttribute('data-rmtag');
      st.tags = st.tags.filter(function (x) { return x !== h; }); go(st); return;
    }
    if ((el = t.closest('[data-rmprice]'))) {
      e.preventDefault(); st = state(); st.p.delete('filter.v.price.lte'); st.p.delete('filter.v.price.gte'); go(st); return;
    }
    if ((el = t.closest('[data-rmparam]'))) {
      e.preventDefault(); st = state(); removeValues(st.p, el.getAttribute('data-rmparam'), [el.getAttribute('data-value')]); go(st); return;
    }
    if ((el = t.closest('[data-freset]'))) {
      e.preventDefault(); st = state(); st.tags = [];
      Array.from(st.p.keys()).forEach(function (k) { if (k.indexOf('filter.') === 0) st.p.delete(k); });
      go(st); return;
    }
    if ((el = t.closest('[data-subtag]'))) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault(); st = state();
      var box = el.closest('[data-subtags]'), all = ((box && box.getAttribute('data-subtags')) || '').split(',').filter(Boolean);
      st.tags = st.tags.filter(function (x) { return all.indexOf(x) < 0; });
      var s = el.getAttribute('data-subtag'); if (s) st.tags.push(s);
      $$('.chipl', box).forEach(function (b) { b.setAttribute('aria-pressed', String(b === el)); });
      go(st); return;
    }
    if ((el = t.closest('a[data-more]'))) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault(); more(el); return;
    }
  });
  var lastKey = window.location.pathname + window.location.search;
  window.addEventListener('popstate', function () {
    var k = window.location.pathname + window.location.search;
    if (k === lastKey) return; lastKey = k;
    if (root()) load(window.location.href, false);
  });

  /* ------------------------------------------------------------ démarrage + éditeur de thème */
  function init() { hoist(); $$('[data-pd-coll][data-client]').forEach(function (r) { cinit(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { init(); });
  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId; if (!id) return;
    $$('.layers [data-pd-ovf="' + id + '"]').forEach(function (ov) { ov.parentNode.removeChild(ov); });
  });
})();
